import React, { ReactElement, ReactNode, useState } from 'react';

export const AccordionGroupSingleOpen = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>();

  return (
    <>
      {React.Children.toArray(children).map((child: ReactElement, i: number) =>
        React.cloneElement(child, {
          expanded:
            activeIndex === undefined && child.props.defaultExpanded
              ? child.props.defaultExpanded
              : i === activeIndex,
          onChange: () =>
            setActiveIndex(
              i === activeIndex ||
                (activeIndex === undefined && child.props.defaultExpanded)
                ? -1
                : i
            ),
          key: child.props.key || i,
        })
      )}
    </>
  );
};
